import React, { useEffect, useState } from 'react'
import ItemsApp, { EmptyItemModel, IItemModel } from './ItemsApp'
import { useNavigate, useParams } from 'react-router-dom'
import { addNewItem, deleteItem, useReturnSingleItem, useReturnSingleItemByUniqueId } from './itemsSlice'
import { useDispatch } from 'react-redux'
import { updateGlobalLoaderStatus, updateQuickNotificationDetails, useReturnGlobalLoaderStatus } from '../notifications/notificationsSlice'
import { handleRequestError } from '../../services/api'
import PageHeadSection from '../admin/components/PageHeadSection'
import NothingFound from '../../components/NothingFound'
import NotFound from '../../components/NotFound'
import SectionBoxContainer from '../../components/SectionBoxContainer'
import SingleItemContent from './SingleItemContent'
import { IBasicDataViewItem } from '../../components/DataDisplayer/BasicDataViewer'

interface IProps {
    disablePageHeadSection?: boolean,
    usePublicDetails?: boolean,
}

export default function ViewSingleItemPageByUniqueId(props: IProps) {

    const { disablePageHeadSection, usePublicDetails } = props

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const params = useParams()
    const itemsApp = new ItemsApp()

    const uniqueId: string = params.id ? params.id : ""
    const [item, setItem] = useState<IItemModel>(EmptyItemModel)

    const [notFound, setNotFound] = useState<boolean>(false)

    const [undoTimeout, setUndoTimeout] = useState<NodeJS.Timeout | null>(null)

    const uploadLoader = (status: boolean) => dispatch(updateGlobalLoaderStatus({ status: status }))
    const loading = useReturnGlobalLoaderStatus()

    /**
     * Load item
     */
    const loadItem = () => {
        if (!uniqueId){
            return;
        }
        
        uploadLoader(true)

        let func = itemsApp.singleItemDetailsByUniqueId(uniqueId, usePublicDetails)

        if (!itemsApp.validateUniqueId(uniqueId)){
            func = itemsApp.singleInstanceDetails(Number(uniqueId))
        }

        func
            .then(response => {

                const result: IItemModel = response.data
                // setItem(result)

                setItem(result)

                setNotFound(false)
                uploadLoader(false)

            })
            .catch(error => {

                const { status } = error.response

                handleRequestError(error, dispatch)

                if (status == 404){
                    setNotFound(true)
                }

                uploadLoader(false)

            })
    }

    /**
     * Handle before delete
     */
    const handleBeforeDelete = () => {
        setNotFound(false)

        if (undoTimeout){
            clearTimeout(undoTimeout)
        }
    }

    /**
     * Delete item
     */
    const handleDeleteItem = () => {
    

        setNotFound(true)

        updateQuickNotificationDetails(true, "Item has been deleted", "error", dispatch, () => {}, 5000, false, [
            {
                label: "Undo",
                handleClose: false,
                onClick: () => handleBeforeDelete()
            }
        ])

        const timeout = setTimeout(() => {
            itemsApp.deleteInstance(item.id)
                .then(response => {
                    dispatch(deleteItem({ id: item.id }))
                    navigate("/panel/items")
                })
                .catch(error => {
                    handleRequestError(error, dispatch)
                })
        }, 5000);
    
        setUndoTimeout(timeout);

    }

    /**
     * Load item
     */
    useEffect(() => {
        loadItem()
    }, [])

    return(
        <div>
           {!disablePageHeadSection && <PageHeadSection 
                pageName="items" 
                customTitle={notFound ? "404" : item.title ? item.title : ""} 
                customActionButtons={[
                    {
                        icon: "delete",
                        variant: "text",
                        label: "Delete",
                        color: "error",
                        onClick: () => handleDeleteItem()
                    },
                    {
                        icon: "edit",
                        variant: "text",
                        link: `/panel/items/edit/${item.id}`,
                        label: "edit",
                        color: "success"
                    }
                ]}
            />}

            {notFound && <SectionBoxContainer><NotFound message="Item doesn't exist." /></SectionBoxContainer>}
            {!notFound && <SingleItemContent item={item} usePublicDetails={usePublicDetails} />}

        </div>
    )
}